import React from 'react'
import { Form, Button, Alert, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { firestore } from '../firebase/firebase-utils'

function KeywordsField(props) {

    const [List, setList] = React.useState([]);
    const [keys, setKeys] = React.useState([]);
    React.useEffect(() => {
        const KeyList = () => {
            firestore.collection(props.collection).onSnapshot((querySnapshot) => {
                var query = querySnapshot.docs.map(doc => {
                    return {
                        ...doc.data(),
                        docid: doc.id,
                    }
                });

                // quering
                query = query.map((item) => (
                    item.keys
                ));


                var list = [];
                query.forEach((item) => (
                    item.forEach((key) => (
                        list.push(key)
                    ))
                ));
                var arrList = [...new Set(list)]
                // iterations count for each number
                var irrCount = [];

                arrList.forEach((item) => {
                    var count = list.reduce((acc, elem) => {
                        return item === elem ? acc + 1 : acc
                    }, 0)
                    irrCount.push({ key: item, count: count })
                })

                irrCount = irrCount.sort((a, b) => {
                    return b.count - a.count
                })
                setList(irrCount)

            });
        }
        KeyList();
        // eslint-disable-next-line
    }, [])

    const handleClick = () => {
        var keyword = document.getElementById("keys").value;
        if (keyword !== '') {
            var list = keys;
            list.push(keyword)
            setKeys(list)
            props.callFunction(list);
            document.getElementById("keys").value = "";
        }
    }

    const DeleteKey = (e) => {
        //deleting keyword
        var delKey = e.target.innerHTML;
        if (delKey !== '') {
            var list = keys;
            list = list.filter(key => key !== delKey)
            setKeys(list);
            props.delete(delKey)
        }
    }

    return (
        <div style={{ padding: '20px', border: '1px solid rgb(241, 240, 240)', borderRadius: '10px' }}>
            {keys.map((keyword) => (
                <OverlayTrigger
                    placement="top"
                    key={keyword}
                    overlay={
                        <Tooltip>
                            onClick removes keyword
                        </Tooltip>
                    }
                >
                    <p onClick={DeleteKey} style={{ color: '#057BD0', backgroundColor: 'rgb(241, 240, 240)', padding: '5px 20px', borderRadius: '25px', width: 'fit-content', marginRight: '5px', display: 'inline-block', cursor: 'pointer' }}>{keyword}</p>
                </OverlayTrigger>
            ))}
            <div style={{ display: 'flex' }}>
                <Form.Control
                    placeholder={props.placeholder}
                    aria-label="add keywords"
                    aria-describedby="basic-addon1"
                    id="keys"
                    list="fruits"
                    style={{ backgroundColor: 'rgb(241, 240, 240)', border: 'none', borderRadius: '25px', padding: '0 20px' }}
                />
                <datalist id="fruits">
                    {List.map((item) => (
                        <option key={item.key}>{item.key}</option>
                    ))}
                </datalist>
                <Button style={{ margin: '0 10px' }} onClick={handleClick}>Add</Button>
            </div>
            <br />
            <Alert variant="success" style={{ fontSize: '14px' }}>
               Note : <br/> 1) Mostly use suggested keywords.<br/>2) Add keywords one-by-one<br/>3) Format : <span style={{color:'tomato'}}>webdevelopment [ wrong ]</span> || <span style={{color:'blue'}}>Web Development [ correct ]</span>
            </Alert>
        </div>
    )
}

export default KeywordsField
